<template>
  <div class="card__wrapper">
    <div class="card">
      <h1 class="card__title">{{ $t('messages.login') }}</h1>
      <div class="card__description">
        <b-form @submit.prevent="login">
          <b-form-group id="emailGroup"
                        v-bind:label="$t('messages.email')+':'"
                        label-for="email"
                        :invalid-feedback="$t('errors.email')">
            <b-form-input id="email" name="email" type="text"
                          autocomplete="email"
                          v-model.trim="form.email"
                          @input="$v.form.email.$touch"
                          :state="$v.form.email.$dirty ? !$v.form.email.$error : null"></b-form-input>
          </b-form-group>
          <b-form-group id="passwordGroup"
                        v-bind:label="$t('messages.password')+':'"
                        label-for="password"
                        :invalid-feedback="$t('errors.password')">
            <b-form-input id="password" name="password" type="password"
                          autocomplete="current-password"
                          v-model.trim="form.password"
                          @input="$v.form.password.$touch"
                          :state="$v.form.password.$dirty ? !$v.form.password.$error : null"></b-form-input>
          </b-form-group>
          <b-form-group id="rememberGroup">
            <b-form-checkbox id="rememberCheckbox" name="rememberCheckbox"
                             v-model="form.remember" class="checkboxLineHeight">{{ $t('messages.remember_me') }}</b-form-checkbox>
          </b-form-group>
          <p>
            <b-link to="requestpassword">{{ $t('messages.forgotpassword') }}</b-link>
          </p>
          <br />
          <b-form-group id="loginGroup">
            <div class="d-flex-responsive align-items-center">
              <notification-button :message="$t('messages.login')" :notification="notifications.login" field="login"
                                   :disabled="$v.form.$invalid"></notification-button>
              <p class="font-italic ml-2 login-register"><b-link to="/register" :title="$t('messages.login_register')">{{ $t('messages.login_register') }}</b-link></p>
            </div>
          </b-form-group>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import NotificationButton from '../components/NotificationButton'

import { notificationMixin } from '../mixin/notification'

import { userService } from '../services/user.service'

export default {
  name: 'login',
  metaInfo: function () {
    return {
      title: this.$i18n.t('messages.login') + ' - CrowdFinder',
      meta: [
        {
          'property': 'og:title',
          'content': this.$i18n.t('messages.login'),
          'vmid': 'og:title'
        }
      ]
    }
  },
  components: { NotificationButton },
  data: function () {
    return {
      form: {},
      notifications: {
        login: null
      }
    }
  },
  mixins: [ validationMixin, notificationMixin ],
  validations: {
    form: {
      email: {
        required,
        email
      },
      password: {
        required
      }
    }
  },
  methods: {
    login: function () {
      if (!this.$v.$invalid) {
        let input = this.$v.form.$model
        let store = this.$store
        let router = this.$router
        let root = this.$root

        userService.login(input).then((response) => {
          store.commit('userId', response.id)
          store.commit('userName', response.fullname)
          store.commit('userRoles', response.roles)
          store.commit('userTotalProjects', response.totalProjects)
          store.commit('lat', response.lat)
          store.commit('lng', response.lng)
          store.commit('city', response.city)
          store.commit('country', response.country)
          store.commit('discounted', response.discounted)
          root.$emit('updateNavigationLocation')
          root.$emit('updateLocale')

          this.$cookies.remove('cf_remember_me')
          if (response.remember) {
            this.$cookies.set('cf_remember_me', response.remember, '1y')
          }

          let locale = response.language
          store.commit('language', locale)
          this.$i18n.locale = locale

          if (store.state.toRoute) {
            router.push(store.state.toRoute)
          } else if (store.state.previousRoute && store.state.previousRoute !== this.$route.path && !store.state.previousRoute.includes('/resetpassword')) {
            router.push(store.state.previousRoute)
          } else {
            router.push('/')
          }
          setTimeout(() => store.commit('success', 'success.login'))
        }, (response) => {
          store.commit('error', 'errors.login')
          this.sendNotification('login', 'error')
        })
      }
    }
  },
  created: function () {
    if (this.$route.query.activate) {
      if (this.$route.query.activate === 'success') {
        this.$store.commit('success', 'success.activated')
      } else {
        this.$store.commit('error', 'errors.activated')
      }
    }
    this.$root.$on('resetNotification', (notification) => {
      this.resetNotification(notification)
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .login-register {
    margin-top: 10px;
  }

  @media screen and (min-width: 901px) {
    .login-register {
      margin-top: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue